import * as Joi from "joi";
import * as React from "react";
import { Button } from "semantic-ui-react";
import { Input, INPUT_TYPE_TEXT } from "./input";
import { Select } from "./select";
import { Dropdown } from "./dropdown";
import { TextArea } from "./textarea";
import { Base, IBaseProps, IBaseState } from "../Common/Base";

export interface IInterfaceFormState extends IBaseState {
  data: any;
  errors: any;
  submitting: boolean;
}

export interface IInterfaceFormProps extends IBaseProps {
  isEdit?: boolean;
  history?: any;
}

export abstract class Form<
  TProps extends IInterfaceFormProps,
  Tstate extends IInterfaceFormState
> extends Base<TProps, Tstate> {
  protected static FORM_INITAL_STATE = {
    ...Base.BASE_INITAL_STATE,
    submitting: false,
  };

  protected schema: Joi.SchemaLike;
  constructor(props: any, schema: Joi.SchemaLike) {
    super(props);

    this.schema = schema;
  }
  protected abstract doSubmit(callBack: () => void): void;

  protected validate = () => {
    const options: Joi.ValidationOptions = { abortEarly: false };
    const { error } = Joi.validate(this.state.data, this.schema, options);
    if (!error) {
      return null;
    }

    const errors = {};
    for (const item of error.details) {
      errors[item.path[0]] = item.message;
    }
    return errors;
  };

  protected handleSubmit = (e: any) => {
    e.preventDefault();
    this.setState({ submitting: true });
    const errors = this.validate();
    this.setState({ errors: errors || {} });
    if (errors) {
      this.setState({ submitting: false });
      return;
    }

    this.doSubmit(() => {
      this.setState({ submitting: false });
    });
  };

  protected renderButton(label: string) {
    const { submitting } = this.state;
    const disabled: boolean = this.validate() !== null;
    return (
      <Button
        disabled={disabled}
        className="btn btn-primary"
        positive={true}
        loading={submitting}
      >
        {label}
      </Button>
    );
  }

  protected renderSubmitButton(label: string) {
    const { submitting } = this.state;
    const disabled: boolean = this.validate() !== null;
    return (
      <Button
        disabled={disabled}
        onClick={this.handleSubmit}
        className="btn btn-primary"
        positive={true}
        loading={submitting}
      >
        {label}
      </Button>
    );
  }

  protected renderSelect(name: string, label: string, options: any[]) {
    const { data, errors } = this.state;

    return (
      <Select
        name={name}
        value={data[name]}
        label={label}
        options={options}
        onChange={this.handleChange}
        error={errors[name]}
      />
    );
  }

  protected renderDropDown(
    name: string,
    label: string,
    options: any[],
    inline: boolean = false
  ) {
    const { data, errors } = this.state;

    return (
      <Dropdown
        name={name}
        value={data[name]}
        label={label}
        options={options}
        selection={true}
        onChange={this.handleChangeData}
        error={errors[name]}
        inline={inline}
      />
    );
  }

  protected renderInput(
    name: string,
    label: string,
    inline: boolean = false,
    placeholder: string = "",
    type: string = INPUT_TYPE_TEXT
  ) {
    const { data, errors } = this.state;

    return (
      <Input
        type={type}
        name={name}
        value={data[name]}
        label={label}
        onChange={this.handleChange}
        error={errors[name]}
        inline={inline}
        placeholder={placeholder}
      />
    );
  }

  protected renderTextArea(id: string, name: string, label: string) {
    const { data, errors } = this.state;

    return (
      <TextArea
        id={id}
        name={name}
        value={data[name]}
        label={label}
        onChange={this.handleChange}
        error={errors[name]}
      />
    );
  }
  private validateProperty = ({ name, value }: any) => {
    const obj = { [name]: value };
    const schema = { [name]: this.schema![name] };
    const { error } = Joi.validate(obj, schema);
    return error ? error.details[0].message : null;
  };

  private handleChange = (event: Event) => {
    const { currentTarget: input } = event;
    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty(input);
    const value = "value";
    const name = "name";
    if (errorMessage) {
      errors[input![name]] = errorMessage;
    } else {
      delete errors[input![name]];
    }

    const data = { ...this.state.data };

    data[input![name]] = input![value];

    this.setState({ data, errors });
  };

  private handleChangeData = (
    event: React.SyntheticEvent,
    selectedData: any
  ) => {
    const errors = { ...this.state.errors };
    const input = {
      name: selectedData.name,
      value: selectedData.value,
    };
    const value = "value";
    const name = "name";
    const errorMessage = this.validateProperty(input);
    if (errorMessage) {
      errors[input![name]] = errorMessage;
    } else {
      delete errors[input![name]];
    }

    const data = { ...this.state.data };

    data[input![name]] = input![value];

    this.setState({ data, errors });
  };
}



// WEBPACK FOOTER //
// ./src/components/Form/index.tsx